import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAFrameComponent } from './simple-icons-a-frame.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAFrameComponent ],
    exports:      [ SimpleIconsAFrameComponent ],
    bootstrap:    []
})
export class SimpleIconsAFrameModule {}
